<app-modal [isLoading]="isLoading" (dismiss)="close()">
  <div modal-header>
    {{ 'admin.tools.generateDocuments.title' | translate }}
  </div>

  <div modal-body class="document-generation-body">
    <div class="document-type">
      <span class="label">{{ 'admin.tools.generateDocuments.documentType' | translate }}</span>
      <span>{{ 'admin.tools.generateDocuments.toolAcceptanceReport' | translate }}</span>
    </div>

    <div class="selected-tools">
      <div class="label">{{ 'admin.tools.generateDocuments.selectedTools' | translate }}</div>
      <app-tool-inspect-tree
        [isScanEnabled]="false"
        [items]="selectedTools">
      </app-tool-inspect-tree>
    </div>
  </div>
  <div modal-footer class="modal-actions">
    <app-button type="simple" [disabled]="isLoading" (clicked)="close()">
      {{ 'generic.buttons.cancel' | translate }}
    </app-button>
    <app-button type="primary" [disabled]="isLoading || !tools.length" (clicked)="confirm()">
      {{ 'generic.buttons.confirm' | translate }}
    </app-button>
  </div>
</app-modal>
